// An enum to track message state in terms of visibility of message
const MessageVisibility = {
    Hidden: 0,
    Visible: 1
};
export default MessageVisibility;
